import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cake } from 'lucide-react';
import { getApproachingBirthdays } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, CardBadge, ListItem, Avatar, ListItemContent, ListItemName, ListItemSub, ListItemBadge, EmptyState, ScrollList } from '../styles';
// KVKK — sunucu yalnız doğum GÜNÜ ve AYINI gönderir (yıl/yaş yok). Gün + ay, dile göre
// yazılır; yıl hiçbir zaman gösterilmez. Sabit artık yıl (2000) 29 Şubat'ı da taşır.
export function formatBirthDayMonth(item, locale) {
  const month = Number(item?.birthMonth);
  const day = Number(item?.birthDay);
  if (!month || !day) return '-';
  try {
    return new Date(2000, month - 1, day).toLocaleDateString(locale, { day: 'numeric', month: 'long' });
  } catch {
    return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}`;
  }
}

export default function BirthdayCard() {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getApproachingBirthdays().then(res => {
      const d = res.data?.data;
      setItems(Array.isArray(d) ? d : []);
    });
  }, []);

  return (
    <Card $delay="0.25s">
      <CardHeader>
        <CardTitle>{t('dashboard.approachingBirthdays')}</CardTitle>
        {items.length > 0 && <CardBadge>{items.length}</CardBadge>}
      </CardHeader>
      {items.length === 0 ? (
        <EmptyState>
          <Cake size={32} />
          {t('dashboard.noBirthdays')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map(item => {
            const initials = item.fullName?.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
            return (
              <ListItem key={item.id}>
                <Avatar $bg="linear-gradient(135deg, #FF6B6B, #FFA07A)">
                  {item.profilePicture ? <img src={item.profilePicture} alt="" /> : initials}
                </Avatar>
                <ListItemContent>
                  <ListItemName>{item.fullName}</ListItemName>
                  <ListItemSub>{formatBirthDayMonth(item, i18n.language)}</ListItemSub>
                </ListItemContent>
                <ListItemBadge $bg={item.daysUntil === 0 ? '#FEE2E2' : '#E8F4FD'} $color={item.daysUntil === 0 ? '#E53935' : '#0291EF'}>
                  {item.daysUntil === 0 ? t('dashboard.today') : `${item.daysUntil} ${t('dashboard.days')}`}
                </ListItemBadge>
              </ListItem>
            );
          })}
        </ScrollList>
      )}
    </Card>
  );
}
